module.exports = __webpack_public_path__ + "static/media/reportCxcInvoicesPaid.c4d3bada.svg";